import { render } from "./QuizSlideView.vue?vue&type=template&id=53ff3025&scoped=true"
import script from "./QuizSlideView.vue?vue&type=script&lang=js"
export * from "./QuizSlideView.vue?vue&type=script&lang=js"

import "./QuizSlideView.vue?vue&type=style&index=0&id=53ff3025&lang=css&scoped=true"

import exportComponent from "C:\\Users\\aarhondakis\\Desktop\\lernapp_quellcode\\lernapp-main\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53ff3025"]])

export default __exports__